/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PostalAddress/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PostalAddress({
  children,
  viewPath = "/DesignSystem/LetterRecipientPicker/Content/PostalAddress",
  onChange
  
}) {
let pickerPostalAddressesLengthValueData = fromData.useDataValue({ viewPath,
context: 'picker',
path: 'postal_addresses.length',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let pickerPostalAddressesValueData = fromData.useDataValue({ viewPath,
context: 'picker',
path: 'postal_addresses',
})
let pickerPostalAddressesLengthValueData1 = fromData.useDataValue({ viewPath,
context: 'picker',
path: 'postal_addresses.length',
})
let pickerPostalAddressIdValueData = fromData.useDataValue({ viewPath,
context: 'picker',
path: 'postal_address_id',
})
let pickerPostalAddressIdChangeData = fromData.useDataChange({ viewPath,
context: 'picker',
path: 'postal_address_id',
})
let pickerPostalAddressesLengthValueData2 = fromData.useDataValue({ viewPath,
context: 'picker',
path: 'postal_addresses.length',
})
  return (<React.Fragment
>
<fromFlow.When is={pickerPostalAddressesLengthValueData}>
<div
  data-testid="PostalAddress.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-Z2ap3gH': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 weight="medium"
 text="Select mailing address to add to the letter"
/>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 marginTop={0}
 data="picker.postal_addresses"
 from={pickerPostalAddressesValueData}
 data="picker.postal_addresses.length"
 disabled={!pickerPostalAddressesLengthValueData1}
 placeholder="Select postal address"
 allowEmptyChoice={false}
 data="picker.postal_address_id"
 value={pickerPostalAddressIdValueData}
 onChange={pickerPostalAddressIdChangeData}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 text="Postal address"
/>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
</React.Fragment>
)}
</TysiaSelectOne>
</div>
</fromFlow.When>
<fromFlow.When is={!pickerPostalAddressesLengthValueData2}>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="picker.postal_addresses.length"
 text="No postal addresses available."
 color={dtColorsNeutral500}
 weight="medium"
/>
</fromFlow.When>
{children}
</React.Fragment>)
}